import { EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BcRevenueTransactionsData } from "../../../../core/models/bcLedgers/BcRevenueTransactionsResponseDto";
import { ChargeBackRequestDto } from "../../../../core/models/bcLedgers/chargeBackRequestDto";
import { BcRevenueTransactionsComponent } from "../bc-revenue-transactions/bc-revenue-transactions.component";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcledgerService } from "../../../../core/services/bcledger.service";

@Component({
  selector: "jni-charge-back",
  templateUrl: "./charge-back.component.html",
  styleUrls: ["./charge-back.component.scss"],
  imports: [BcRevenueTransactionsComponent],
})
export class ChargeBackComponent implements OnInit, OnChanges {
  chargeBackParams!: ChargeBackRequestDto;
  @Input() bcLedgerStacker!: BcLedgerStacker;
  chargeBackList: BcRevenueTransactionsData[] = [];
  TotalBCRevenue!: number;
  TotalBCGP!: number;
  BCAvgMargin!: number;
  TotalBCCommission!: number;
  TotalBCReserve!: number;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _chargeBackService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.chargeBackParams = { ...params } as ChargeBackRequestDto;
      this.chargeBackParams.CategoryID = "";
    });
  }

  ngOnInit(): void {
    this.getChargeBack(this.chargeBackParams);
  }

  getChargeBack(payload: ChargeBackRequestDto) {
    this._loaderService.setLoaderState(true);
    this._chargeBackService.chargeBack(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.chargeBackList = res.data.Data ?? [];
          this.TotalBCRevenue = res.data.TotalBCRevenue;
          this.TotalBCGP = res.data.TotalBCGP;
          this.BCAvgMargin = res.data.BCAvgMargin;
          this.TotalBCCommission = res.data.TotalBCCommission;
          this.TotalBCReserve = res.data.TotalBCReserve;
          return;
        }
        this._toastrService.error(
          res.message ?? "ChargeBack Fetched",
          "ChargeBack"
        );
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.chargeBackParams = { ...this.bcLedgerStacker };
      this.chargeBackParams.CategoryID = "";
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
